import {KbtGapState, KbtGapStates} from './models';

const whiteSpaceRegex = new RegExp('\\s+', 'g');

function stripExtraWhitespace(value: string): string {
  let next = value;
  do {
    value = next;
    next = value.replace(whiteSpaceRegex, ' ');
  } while (next !== value);
  return value;
}

export function isMatch(value1: string, value2: string): boolean {
  if (value1 === value2)
    return true;
  value1 = stripExtraWhitespace(value1.trim());
  value2 = stripExtraWhitespace(value2.trim());
  if (value1 === value2)
    return true;
  return value1.toLowerCase() === value2.toLowerCase();
}

/******************************************************************************/

export function checkAllItems(states: KbtGapStates): KbtGapStates {
  const result: { [index: string]: KbtGapState } = {};
  for (let [itemId, state] of Object.entries(states)) {
    if (state.checked || state.filledWith === '')
      result[itemId] = state;
    else
      result[itemId] = {
        filledWith: state.filledWith,
        checked: true,
        checkCount: state.checkCount + 1
      };
  }

  return result;
}
